<template>
    <div id="news">
        <vue-title title="Главная | Грузоперевозки KEL"></vue-title>
        <Header :routes="headerRoutes.defaultsoutes"/>
        <div class="home-slider pt-3">
            <div class="container mt-4 mb-5">
                <div class="owl-carousel owl-loaded owl-drag d-none d-md-block">
<!--                    <img src="@/assets/images/sliders/home/0.jpg">-->
                    <img src="@/assets/images/sliders/home/1.jpg">
                    <img src="@/assets/images/sliders/home/2.jpg">
                </div>
<!--                <div class="owl-carousel owl-loaded owl-drag d-block d-md-none">-->
<!--                    <img src="@/assets/images/sliders/home/0_min.jpg">-->
<!--                </div>-->
            </div>
        </div>
<!--        <div id="auto-transportation" class="container mt-4 mb-5">-->
<!--            <section class="global d-md-flex flex">-->
<!--                <div class="direction-title d-flex flex-row flex-md-column align-items-start justify-content-between justify-content-md-start">-->
<!--                    <img src="@/assets/images/auto-label.png" class="img-fluid mb-3">-->
<!--                    <div class="text-right text-md-left">Автоперевозки</div>-->
<!--                </div>-->
<!--                <div class="main-direction-carousel">-->
<!--                    <div class="owl-carousel owl-loaded">-->
<!--                        <router-link :to="{ name: 'Marketplace' }" class="direction-item" title="Ищу груз">-->
<!--                            <div class="ico">-->
<!--                                <svg id="_018-search-2" data-name="018-search-2" xmlns="http://www.w3.org/2000/svg"-->
<!--                                     width="64" height="64" viewBox="0 0 64 64">-->
<!--                                    <g id="Сгруппировать_2681" data-name="Сгруппировать 2681"-->
<!--                                       transform="translate(18.274 41)">-->
<!--                                        <g id="Сгруппировать_2680" data-name="Сгруппировать 2680">-->
<!--                                            <path id="Контур_1879" data-name="Контур 1879"-->
<!--                                                  d="M148.326,328.365a1.249,1.249,0,1,0,.366.884A1.262,1.262,0,0,0,148.326,328.365Z"-->
<!--                                                  transform="translate(-146.192 -327.999)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2683" data-name="Сгруппировать 2683">-->
<!--                                        <g id="Сгруппировать_2682" data-name="Сгруппировать 2682">-->
<!--                                            <path id="Контур_1880" data-name="Контур 1880"-->
<!--                                                  d="M63.206,24.884a1.25,1.25,0,1,0-2.438.554,29.6,29.6,0,0,1,.7,5.312H48.532a58.384,58.384,0,0,0-1.664-12.915,4.254,4.254,0,0,0,1.8-2.909,13.89,13.89,0,0,0,5.041-2.894A29.459,29.459,0,0,1,56.1,14.987a1.25,1.25,0,1,0,2.041-1.443A31.963,31.963,0,0,0,32,0,32,32,0,0,0,0,32a32.227,32.227,0,0,0,.658,6.488,1.25,1.25,0,0,0,2.449-.5,29.628,29.628,0,0,1-.578-4.733H8a1.25,1.25,0,0,0,0-2.5H2.529A29.387,29.387,0,0,1,10.3,12.038a13.9,13.9,0,0,0,4.913,2.849,4.254,4.254,0,0,0,1.9,3.012,55.458,55.458,0,0,0-1.4,8.357,1.25,1.25,0,0,0,1.13,1.359c.039,0,.078.005.116.005A1.25,1.25,0,0,0,18.2,26.486a53,53,0,0,1,1.318-7.9,4.257,4.257,0,0,0,3.966-3H30.75v21a13.721,13.721,0,0,0-6.323-4.911,1.25,1.25,0,1,0-.892,2.335,11.321,11.321,0,0,1,7.215,9.83v.684a1.256,1.256,0,0,0,.02.219A11.25,11.25,0,1,1,15.217,34.126a1.25,1.25,0,1,0-.958-2.309,13.746,13.746,0,0,0-3.3,23.459L5.205,61.035a1.585,1.585,0,1,1-2.241-2.241L6.449,55.31a1.25,1.25,0,0,0-1.768-1.768L1.2,57.027A4.085,4.085,0,0,0,6.973,62.8L13.1,56.677a13.739,13.739,0,0,0,18.613-5.8,1.253,1.253,0,0,0,.288.035h8.234a4.266,4.266,0,0,0,1.52,2.154c-2.334,4.743-5.359,7.684-8.5,8.306V57.021a1.25,1.25,0,0,0-2.5,0v4.452a29.434,29.434,0,0,1-7.535-1.3,1.25,1.25,0,0,0-.744,2.387A32,32,0,0,0,31.991,64h.037A32,32,0,0,0,64,32,32.174,32.174,0,0,0,63.206,24.884ZM15.649,12.392a11.4,11.4,0,0,1-3.577-2.123A29.481,29.481,0,0,1,24.385,3.5a23.472,23.472,0,0,0-4.519,6.609,4.247,4.247,0,0,0-4.217,2.284Zm3.778,3.693a1.75,1.75,0,1,1,1.75-1.75A1.752,1.752,0,0,1,19.427,16.085Zm11.323-3H23.489a4.262,4.262,0,0,0-1.321-1.994c2.344-4.838,5.4-7.837,8.582-8.465Zm21.186-2.823a11.388,11.388,0,0,1-3.681,2.164,4.254,4.254,0,0,0-3.8-2.341c-.111,0-.221.006-.33.014a23.48,23.48,0,0,0-4.5-6.59A29.617,29.617,0,0,1,51.936,10.262ZM46.21,14.335a1.75,1.75,0,1,1-1.75-1.75A1.752,1.752,0,0,1,46.21,14.335ZM33.25,2.626c3.166.625,6.209,3.6,8.549,8.4a4.263,4.263,0,0,0-1.4,2.061H33.25Zm0,12.959H40.4a4.257,4.257,0,0,0,4.062,3h.02A55.932,55.932,0,0,1,46.031,30.75H33.25Zm6.984,32.829H32.711a13.706,13.706,0,0,0,.562-3.892c0-.255-.009-.509-.023-.762V33.25H46.032a55.947,55.947,0,0,1-1.547,12.169c-.063,0-.125,0-.189,0A4.257,4.257,0,0,0,40.234,48.415Zm5.812,1.25a1.75,1.75,0,1,1-1.75-1.75A1.752,1.752,0,0,1,46.046,49.665ZM39.616,60.5a23.46,23.46,0,0,0,4.509-6.591c.057,0,.114,0,.171,0a4.255,4.255,0,0,0,3.821-2.39,11.367,11.367,0,0,1,3.812,2.206A29.482,29.482,0,0,1,39.616,60.5ZM53.7,51.962a13.872,13.872,0,0,0-5.2-2.942,4.253,4.253,0,0,0-1.648-2.751A58.325,58.325,0,0,0,48.533,33.25H61.472A29.387,29.387,0,0,1,53.7,51.962Z"-->
<!--                                                  fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2685" data-name="Сгруппировать 2685"-->
<!--                                       transform="translate(58.889 18.331)">-->
<!--                                        <g id="Сгруппировать_2684" data-name="Сгруппировать 2684">-->
<!--                                            <path id="Контур_1881" data-name="Контур 1881"-->
<!--                                                  d="M473.535,147.462l-.031-.069a1.25,1.25,0,1,0-2.288,1.007l.028.064a1.25,1.25,0,1,0,2.291-1Z"-->
<!--                                                  transform="translate(-471.11 -146.646)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2687" data-name="Сгруппировать 2687"-->
<!--                                       transform="translate(18.273 30.773)">-->
<!--                                        <g id="Сгруппировать_2686" data-name="Сгруппировать 2686">-->
<!--                                            <path id="Контур_1882" data-name="Контур 1882"-->
<!--                                                  d="M147.515,246.185h-.077a1.25,1.25,0,0,0,0,2.5h.071a1.25,1.25,0,0,0,.006-2.5Z"-->
<!--                                                  transform="translate(-146.188 -246.185)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2689" data-name="Сгруппировать 2689"-->
<!--                                       transform="translate(12.399 35.562)">-->
<!--                                        <g id="Сгруппировать_2688" data-name="Сгруппировать 2688">-->
<!--                                            <path id="Контур_1883" data-name="Контур 1883"-->
<!--                                                  d="M106.315,284.5a7.123,7.123,0,0,0-5.551,11.585l.033.044,4.533,5.807a1.25,1.25,0,0,0,1.971,0l4.555-5.838,0,0a7.122,7.122,0,0,0-5.543-11.595Zm3.585,10.04-.034.044-3.551,4.552-3.5-4.478q-.033-.048-.07-.094a4.623,4.623,0,1,1,8.188-2.942A4.568,4.568,0,0,1,109.9,294.539Z"-->
<!--                                                  transform="translate(-99.192 -284.499)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                </svg>-->
<!--                                <p>Ищу груз</p>-->
<!--                            </div>-->
<!--                        </router-link>-->
<!--                        <router-link :to="{ name: 'Dev' }" class="direction-item" title="Ищу транспорт">-->
<!--                            <div class="ico">-->
<!--                                <svg id="shipped" xmlns="http://www.w3.org/2000/svg" width="82.111" height="51.941"-->
<!--                                     viewBox="0 0 82.111 51.941">-->
<!--                                    <g id="Сгруппировать_2576" data-name="Сгруппировать 2576"-->
<!--                                       transform="translate(0 0)">-->
<!--                                        <g id="Сгруппировать_2575" data-name="Сгруппировать 2575">-->
<!--                                            <path id="Контур_1844" data-name="Контур 1844"-->
<!--                                                  d="M76.363,116.081l-2.126-8.505a1.286,1.286,0,0,0,1.018-1.257v-1.371a5.406,5.406,0,0,0-5.4-5.4H60.169V96.719a2.66,2.66,0,0,0-2.657-2.657H8.142a2.66,2.66,0,0,0-2.657,2.657v23.313a1.286,1.286,0,1,0,2.571,0V96.719a.086.086,0,0,1,.086-.086h49.37a.086.086,0,0,1,.086.086v23.314a1.286,1.286,0,0,0,2.571,0v-1.457H75.342a4.207,4.207,0,0,1,4,2.914h-4a1.286,1.286,0,0,0-1.286,1.286v2.743a4.033,4.033,0,0,0,4.028,4.028H79.54V135.2H76.178a8.14,8.14,0,0,0-15.39,0h-.619v-9.685a1.286,1.286,0,0,0-2.571,0V135.2H30.923a8.14,8.14,0,0,0-15.39,0H8.142a.086.086,0,0,1-.086-.086v-2.829h5.571a1.286,1.286,0,1,0,0-2.571H1.286a1.286,1.286,0,1,0,0,2.571h4.2v2.829a2.66,2.66,0,0,0,2.657,2.657h6.945c0,.029,0,.057,0,.086a8.142,8.142,0,0,0,16.285,0c0-.029,0-.057,0-.086H60.343c0,.029,0,.057,0,.086a8.142,8.142,0,0,0,16.285,0c0-.029,0-.057,0-.086h4.2a1.286,1.286,0,0,0,1.286-1.286V122.775A6.781,6.781,0,0,0,76.363,116.081ZM60.169,102.119h9.685a2.832,2.832,0,0,1,2.829,2.829v.086H60.169Zm0,13.885v-8.4H71.593l2.1,8.4H60.169ZM23.228,143.432A5.571,5.571,0,1,1,28.8,137.86,5.577,5.577,0,0,1,23.228,143.432Zm45.256,0a5.571,5.571,0,1,1,5.571-5.571A5.577,5.577,0,0,1,68.483,143.432ZM79.54,126.975H78.083a1.459,1.459,0,0,1-1.457-1.457v-1.457H79.54v2.914Z"-->
<!--                                                  transform="translate(0 -94.062)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2578" data-name="Сгруппировать 2578"-->
<!--                                       transform="translate(20.571 41.141)">-->
<!--                                        <g id="Сгруппировать_2577" data-name="Сгруппировать 2577">-->
<!--                                            <path id="Контур_1845" data-name="Контур 1845"-->
<!--                                                  d="M130.924,350.6a2.657,2.657,0,1,0,2.657,2.657A2.66,2.66,0,0,0,130.924,350.6Z"-->
<!--                                                  transform="translate(-128.267 -350.597)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2580" data-name="Сгруппировать 2580"-->
<!--                                       transform="translate(65.826 41.141)">-->
<!--                                        <g id="Сгруппировать_2579" data-name="Сгруппировать 2579">-->
<!--                                            <path id="Контур_1846" data-name="Контур 1846"-->
<!--                                                  d="M413.112,350.6a2.657,2.657,0,1,0,2.657,2.657A2.66,2.66,0,0,0,413.112,350.6Z"-->
<!--                                                  transform="translate(-410.455 -350.597)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2582" data-name="Сгруппировать 2582"-->
<!--                                       transform="translate(32.913 35.656)">-->
<!--                                        <g id="Сгруппировать_2581" data-name="Сгруппировать 2581">-->
<!--                                            <path id="Контур_1847" data-name="Контур 1847"-->
<!--                                                  d="M225.712,316.393h-19.2a1.286,1.286,0,1,0,0,2.571h19.2a1.286,1.286,0,1,0,0-2.571Z"-->
<!--                                                  transform="translate(-205.227 -316.393)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2584" data-name="Сгруппировать 2584"-->
<!--                                       transform="translate(2.743 30.17)">-->
<!--                                        <g id="Сгруппировать_2583" data-name="Сгруппировать 2583">-->
<!--                                            <path id="Контур_1848" data-name="Контур 1848"-->
<!--                                                  d="M34.844,282.188H18.388a1.286,1.286,0,0,0,0,2.571H34.844a1.286,1.286,0,0,0,0-2.571Z"-->
<!--                                                  transform="translate(-17.102 -282.188)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                    <g id="Сгруппировать_2586" data-name="Сгруппировать 2586"-->
<!--                                       transform="translate(23.313 12.342)">-->
<!--                                        <g id="Сгруппировать_2585" data-name="Сгруппировать 2585">-->
<!--                                            <path id="Контур_1849" data-name="Контур 1849"-->
<!--                                                  d="M166.764,171.4a1.286,1.286,0,0,0-1.818,0l-11.433,11.433-5.948-5.948a1.286,1.286,0,0,0-1.818,1.818l6.857,6.857a1.285,1.285,0,0,0,1.818,0l12.342-12.342A1.286,1.286,0,0,0,166.764,171.4Z"-->
<!--                                                  transform="translate(-145.37 -171.023)" fill="#979797"></path>-->
<!--                                        </g>-->
<!--                                    </g>-->
<!--                                </svg>-->
<!--                                <p>Ищу транспорт</p>-->
<!--                            </div>-->
<!--                        </router-link>-->
<!--                        <router-link :to="{ name: 'Dev' }" class="direction-item" title="Отслеживание груза">-->
<!--                            <div class="ico">-->
<!--                                <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65">-->
<!--                                    <g id="container" transform="translate(-8 -8)">-->
<!--                                        <path id="Контур_1914" data-name="Контур 1914"-->
<!--                                              d="M249.048,264A1.048,1.048,0,0,0,248,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,249.048,264Z"-->
<!--                                              transform="translate(-208.548 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1915" data-name="Контур 1915"-->
<!--                                              d="M209.048,264A1.048,1.048,0,0,0,208,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,209.048,264Z"-->
<!--                                              transform="translate(-173.79 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1916" data-name="Контур 1916"-->
<!--                                              d="M169.048,264A1.048,1.048,0,0,0,168,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,169.048,264Z"-->
<!--                                              transform="translate(-139.032 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1917" data-name="Контур 1917"-->
<!--                                              d="M129.048,264A1.048,1.048,0,0,0,128,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,129.048,264Z"-->
<!--                                              transform="translate(-104.274 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1918" data-name="Контур 1918"-->
<!--                                              d="M89.048,264A1.048,1.048,0,0,0,88,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,89.048,264Z"-->
<!--                                              transform="translate(-69.516 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1919" data-name="Контур 1919"-->
<!--                                              d="M49.048,264A1.048,1.048,0,0,0,48,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,49.048,264Z"-->
<!--                                              transform="translate(-34.758 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1920" data-name="Контур 1920"-->
<!--                                              d="M449.048,264A1.048,1.048,0,0,0,448,265.048v16.774a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,449.048,264Z"-->
<!--                                              transform="translate(-382.339 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1921" data-name="Контур 1921"-->
<!--                                              d="M409.048,264A1.048,1.048,0,0,0,408,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,409.048,264Z"-->
<!--                                              transform="translate(-347.581 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1922" data-name="Контур 1922"-->
<!--                                              d="M369.048,264A1.048,1.048,0,0,0,368,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,369.048,264Z"-->
<!--                                              transform="translate(-312.823 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1923" data-name="Контур 1923"-->
<!--                                              d="M329.048,264A1.048,1.048,0,0,0,328,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,329.048,264Z"-->
<!--                                              transform="translate(-278.065 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1924" data-name="Контур 1924"-->
<!--                                              d="M289.048,264A1.048,1.048,0,0,0,288,265.048v20.968a1.048,1.048,0,1,0,2.1,0V265.048A1.048,1.048,0,0,0,289.048,264Z"-->
<!--                                              transform="translate(-243.306 -222.452)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1925" data-name="Контур 1925"-->
<!--                                              d="M449.048,416A1.048,1.048,0,0,0,448,417.048V418.1a1.048,1.048,0,0,0,2.1,0v-1.048A1.048,1.048,0,0,0,449.048,416Z"-->
<!--                                              transform="translate(-382.339 -354.532)" fill="#979797"></path>-->
<!--                                        <path id="Контур_1926" data-name="Контур 1926"-->
<!--                                              d="M71.952,34.21H66.915L44.484,25.032a4.191,4.191,0,0,0-2.935-5.368V17.435H42.6a1.048,1.048,0,0,0,1.048-1.048v-2.1h9.435a1.048,1.048,0,0,0,1.048-1.048V9.048A1.048,1.048,0,0,0,53.081,8H27.919a1.048,1.048,0,0,0-1.048,1.048v4.194a1.048,1.048,0,0,0,1.048,1.048h9.435v2.1A1.048,1.048,0,0,0,38.4,17.435h1.048v3.145A1.048,1.048,0,0,0,40.5,21.629a2.1,2.1,0,1,1-2.1,2.1,1.048,1.048,0,1,0-2.1,0,4.185,4.185,0,0,0,.21,1.307L14.085,34.21H9.048A1.048,1.048,0,0,0,8,35.258V71.952A1.048,1.048,0,0,0,9.048,73h62.9A1.048,1.048,0,0,0,73,71.952V35.258A1.048,1.048,0,0,0,71.952,34.21ZM28.968,12.194V10.1H52.032v2.1Zm10.484,3.145V14.29h2.1v1.048ZM15.339,35.962l22.339-9.138a4.184,4.184,0,0,0,5.646,0l22.339,9.138v1.393H15.339Zm-5.242.345h3.145v1.048H10.1ZM70.9,70.9H10.1v-2.1H70.9Zm0-4.194H10.1V39.452H70.9Zm0-29.355H67.758V36.306H70.9Z"-->
<!--                                              fill="#979797"></path>-->
<!--                                    </g>-->
<!--                                </svg>-->
<!--                                <p>Отслеживание груза</p>-->
<!--                            </div>-->
<!--                        </router-link>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </section>-->
<!--        </div>-->
        <div id="online-orders" class="online-orders">
            <div class="filter-wrap pt-3 pb-3">
                <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="title">Новые грузы</div>
                        <div class="total">Всего: <span class="text-primary">{{ cargos ? cargos.totals : 0 }}</span></div>
                    </div>
                </div>
            </div>
            <div class="bg-white py-4">
                <div class="container">
                    <div v-if="!cargos" class="mb-3">
                        <DxLoadIndicator
                                id="medium-indicator"
                                :height="20"
                                :width="20"
                        />
                        Загрузка
                    </div>
                    <div v-if="cargos">
                        <div v-if="cargos.totals == 0">
                            <strong><i class="fas fa-search mr-2"></i>Ничего не найдено.</strong>
                        </div>
                        <div class="row" v-if="cargos.totals > 0">
                            <div class="col-12 col-lg-6 mb-4" v-for="cargoItem in cargos.items" :key="cargoItem.cargoLotId">
                                <div class="card h-100 shadow-sm">
                                    <div class="bg-primary" style="border-top-left-radius: 0.25rem; border-top-right-radius: 0.25rem;">
                                        <div class="row">
                                            <div class="col-4 text-left text-white py-1">
                                                <small class="mb-2 pl-3">{{ cargoItem.cargoLotNumber }}</small>
                                            </div>
                                            <div class="col-4 text-center p-0">
                                                <small class="bg-white mb-2 px-2 pb-1" style="border-bottom-right-radius: 0.25rem; padding-top: 0.3rem; border-bottom-left-radius: 0.25rem;"><span v-html="getStatus(cargoItem)"></span></small>
                                            </div>
                                            <div class="col-4 text-right text-white py-1">
                                                <small class="mb-2 pr-3">{{ cargoItem.pickupDate | moment("DD.MM.YYYY") }}</small>
                                            </div>
                                        </div>
                                        <div class="text-white px-3 pt-0 pb-2">
                                            {{ cargoItem.cargo.descriptionOfCargo }}
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-2 col-sm-1">
                                                <i class="fas fa-map-marked-alt font-20 text-muted"></i>
                                            </div>
                                            <div class="col-10 col-sm-11">
                                                <span class="text-primary link-revert" @click="openRoute(cargoItem.cargoLotId)">{{ cargoItem.routeCaption }}</span>
                                                <div class="modal fade" :id="'routeModal'+cargoItem.cargoLotId" tabindex="-1"
                                                     :aria-labelledby="'routeModalLabel'+cargoItem.cargoLotId"
                                                     aria-hidden="true">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title"
                                                                    :id="'routeModalLabel'+cargoItem.cargoLotId">Информация по
                                                                    маршруту</h5>
                                                                <button type="button" class="close" data-dismiss="modal"
                                                                        aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <strong>Маршрут:</strong>
                                                                <p class="font-12">{{ cargoItem.routeCaption }}</p>
                                                                <strong>Адреса:</strong>
                                                                <div v-if="!selectRoute" class="mb-3">
                                                                    <DxLoadIndicator
                                                                        id="medium-indicator-routes"
                                                                        :height="20"
                                                                        :width="20"
                                                                    />
                                                                    Загрузка
                                                                </div>
                                                                <table v-if="selectRoute" class="table table-borderless font-12">
                                                                    <tbody>
                                                                    <tr v-for="(route, index) in selectRoute"
                                                                        :key="route.routePointId">
                                                                        <td class="pb-0">
                                                                            <div class="row">
                                                                                <div class="col-12 pb-3 d-flex align-items-center"
                                                                                     v-if="index > 0">
                                                                                    <i class="fas fa-long-arrow-alt-down text-yellow"
                                                                                       style="font-size: 25px"></i><strong
                                                                                    class="text-primary ml-3"
                                                                                    v-if="route.distance > 0">{{
                                                                                        route.distance }} км</strong>
                                                                                </div>
                                                                                <div class="col-3 pr-0">
                                                                                    <div v-if="route.operationType == 'rptLoading'"
                                                                                         class="h-100 d-flex align-items-center">
                                                                                        <i class="fas fa-arrow-right pr-1 text-danger"
                                                                                           style="font-size: 20px"></i><i
                                                                                        class="fas fa-truck-loading text-danger"
                                                                                        style="font-size: 25px"></i>
                                                                                    </div>
                                                                                    <div v-if="route.operationType == 'rtpUnloading'"
                                                                                         class="h-100 d-flex align-items-center">
                                                                                        <i class="fas fa-arrow-left pr-1 text-secondary"
                                                                                           style="font-size: 20px"></i><i
                                                                                        class="fas fa-truck-loading text-secondary"
                                                                                        style="font-size: 25px"></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-9 pl-0">
                                                                                    <span v-if="isViewTime(route.operationTime)">{{ route.operationTime | moment("DD.MM.YYYY HH:mm") }}<br>{{ route.address.localityDisplay }}</span>
                                                                                    <span v-if="!isViewTime(route.operationTime)">{{ route.operationTime | moment("DD.MM.YYYY") }}<br>{{ route.address.localityDisplay }}</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn btn-secondary mr-2"
                                                                        data-dismiss="modal">Закрыть
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-2 col-sm-1">
                                                <i class="fas fa-truck-moving font-20 text-muted"></i>
                                            </div>
                                            <div class="col-10 col-sm-11">
                                                {{ cargoItem.cargo.rollingStockRequestDisplay }}
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-2 col-sm-1">
                                                <i class="fas fa-exclamation-triangle font-20 text-warning"></i>
                                            </div>
                                            <div class="col-10 col-sm-11">
                                                Особые условия: {{ cargoItem.cargo.additionCarriageTerm }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="row">
                                            <div class="col-6 col-sm-4">
                                                <button type="button"
                                                        class="btn btn-outline-primary btn-sm" @click="openOffers(cargoItem.cargoLotId)">
                                                    <span class="small">ВСЕ ПРЕДЛОЖЕНИЯ</span>
                                                </button>
                                                <div class="modal fade" :id="'offersModal'+cargoItem.cargoLotId" tabindex="-1"
                                                     :aria-labelledby="'offersModalLabel'+cargoItem.cargoLotId"
                                                     aria-hidden="true">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title"
                                                                    :id="'offersModalLabel'+cargoItem.cargoLotId">
                                                                    Предложения</h5>
                                                                <button type="button" class="close" data-dismiss="modal"
                                                                        aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <div v-if="!selectOffers" class="mb-3">
                                                                    <DxLoadIndicator
                                                                        id="medium-indicator-offers"
                                                                        :height="20"
                                                                        :width="20"
                                                                    />
                                                                    Загрузка
                                                                </div>
                                                                <div v-if="selectOffers && selectOffers.length == 0">
                                                                    <div class="row">
                                                                        <div class="col-12">
                                                                            На данный момент предложений нет.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <table v-if="selectOffers && selectOffers.length > 0" class="table mb-0 font-12">
                                                                    <tbody>
                                                                    <tr v-for="(offer, index) in selectOffers"
                                                                        :key="offer.cargoOfferId">
                                                                        <td style="border: 0px; width: 5px;" class="pl-1 pr-0"><i v-if="offer.status == 'oisApproved'" class="fas fa-check-circle text-success"></i></td>
                                                                        <td style="border: 0px; width: 10px;" class="pr-0">{{ index+1 }}:</td>
                                                                        <td style="border: 0px; width: 130px">{{
                                                                                offer.timeCreate | moment("DD.MM.YYYY HH:mm") }}
                                                                        </td>
                                                                        <td style="border: 0px">{{
                                                                                offer.rollingStockUnitTypeName }}
                                                                        </td>
                                                                        <td class="text-right"
                                                                            style="border: 0px; width: 120px"><strong>{{
                                                                                offer.amount | formatMoney }}  {{ offer.currencyShortName }}</strong></td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn btn-secondary mr-2"
                                                                        data-dismiss="modal">Закрыть
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6 col-sm-4 text-right text-sm-center">
                                                <div v-if="!cargoItem.agentOffer">
                                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                                            data-toggle="modal" data-target="#noLoginModal" v-if="!isLogged">
                                                        <i class="fas fa-file-invoice-dollar font-18 mr-1"></i><span
                                                        class="small">ПРЕДЛОЖИТЬ ЦЕНУ</span>
                                                    </button>
                                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                                            @click="openAddOfferModal(cargoItem.cargoLotId, cargoItem.rollingStockTypeId)"
                                                            v-if="isLogged">
                                                        <i class="fas fa-file-invoice-dollar font-18 mr-1"></i><span
                                                        class="small">ПРЕДЛОЖИТЬ ЦЕНУ</span>
                                                    </button>
                                                    <div class="modal fade" :id="'addOfferModal'+cargoItem.cargoLotId"
                                                         tabindex="-1"
                                                         :aria-labelledby="'addOfferModalLabel'+cargoItem.cargoLotId"
                                                         aria-hidden="true">
                                                        <div class="modal-dialog modal-lg">
                                                            <div class="modal-content">
                                                                <div class="modal-header text-left">
                                                                    <h5 class="modal-title"
                                                                        :id="'addOfferModalLabel'+cargoItem.cargoLotId">Добавить
                                                                        предложение: <strong>{{ cargoItem.cargoLotNumber
                                                                            }}</strong></h5>
                                                                    <button type="button" class="close" data-dismiss="modal"
                                                                            aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                                </div>
                                                                <div class="modal-body">
                                                                    <div v-if="errorMessageAddOffer"
                                                                         class="alert alert-danger mb-3" role="alert">
                                                                        <strong>Внимание!</strong> {{ errorMessageAddOffer }}
                                                                    </div>
                                                                    <DxForm
                                                                        :col-count="1"
                                                                        :form-data="offerNew"
                                                                        :label-location="labelLocation"
                                                                        :ref="'addOfferFormRef'+cargoItem.cargoLotId"
                                                                        :show-colon-after-label="true"
                                                                        :show-validation-summary="true"
                                                                        :disabled="isSendOffer"
                                                                    >
                                                                        <DxGroupItem :colCount="3">
                                                                            <DxColCountByScreen :xs="1" :sm="1"/>
                                                                            <DxSimpleItem
                                                                                :editor-options="{value: offerNew.rollingStockUnitTypeId, searchEnabled: true, dataSource: storeRollingStockUnitTypes, displayExpr: 'rollingStockUnitTypeName', valueExpr: 'rollingStockUnitTypeId', showClearButton: true}"
                                                                                data-field="rollingStockUnitTypeId"
                                                                                editor-type="dxSelectBox"
                                                                            >
                                                                                <DxLabel text="Тип ПС"/>
                                                                                <DxRequiredRule message="Укажите Тип ПС"/>
                                                                            </DxSimpleItem>
                                                                            <DxSimpleItem
                                                                                :editor-options="{value: offerNew.amount}"
                                                                                data-field="amount"
                                                                                editor-type="dxNumberBox"
                                                                            >
                                                                                <DxLabel text="Ваше предложение"/>
                                                                                <DxRequiredRule/>
                                                                            </DxSimpleItem>
                                                                            <DxSimpleItem
                                                                                :editor-options="{value: offerNew.currencyId, items: currencys, displayExpr: 'сurrencyName', valueExpr: 'сurrencyId', showClearButton: true, searchEnabled: true}"
                                                                                data-field="currencyId"
                                                                                editor-type="dxSelectBox"
                                                                            >
                                                                                <DxLabel text="Валюта"/>
                                                                                <DxRequiredRule message="Укажите Валюту"/>
                                                                            </DxSimpleItem>
                                                                        </DxGroupItem>
                                                                        <DxSimpleItem
                                                                            :editor-options="{value: offerNew.note}"
                                                                            data-field="note"
                                                                            editor-type="dxTextBox"
                                                                        >
                                                                            <DxLabel text="Комментарий"/>
                                                                        </DxSimpleItem>
                                                                    </DxForm>
                                                                </div>
                                                                <div class="modal-footer">
                                                                    <button type="button" class="btn btn-primary"
                                                                            @click="AddOffer(cargoItem.cargoLotId)"
                                                                            :disabled="isSendOffer">Сохранить
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="cargoItem.agentOffer">
                                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                                            @click="openEditOfferModal(cargoItem.cargoLotId, cargoItem.rollingStockTypeId, cargoItem.agentOffer)">
                                                        <i class="fas fa-file-invoice-dollar font-18 mr-1"></i><span
                                                        class="small">ИЗМЕНИТЬ ЦЕНУ</span>
                                                    </button>
                                                    <div class="modal fade" :id="'editOfferModal'+cargoItem.cargoLotId"
                                                         tabindex="-1"
                                                         :aria-labelledby="'editOfferModalLabel'+cargoItem.cargoLotId"
                                                         aria-hidden="true">
                                                        <div class="modal-dialog modal-lg">
                                                            <div class="modal-content">
                                                                <div class="modal-header text-left">
                                                                    <h5 class="modal-title"
                                                                        :id="'editOfferModalLabel'+cargoItem.cargoLotId">
                                                                        Изменить предложение: <strong>{{
                                                                            cargoItem.cargoLotNumber }}</strong></h5>
                                                                    <button type="button" class="close" data-dismiss="modal"
                                                                            aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                                </div>
                                                                <div class="modal-body">
                                                                    <div v-if="errorMessageEditOffer"
                                                                         class="alert alert-danger mb-3" role="alert">
                                                                        <strong>Внимание!</strong> {{ errorMessageEditOffer }}
                                                                    </div>
                                                                    <DxForm
                                                                        :col-count="1"
                                                                        :form-data="offerEdit"
                                                                        :label-location="labelLocation"
                                                                        :ref="'editOfferFormRef'+cargoItem.cargoLotId"
                                                                        :show-colon-after-label="true"
                                                                        :show-validation-summary="true"
                                                                        :disabled="isSendOffer"
                                                                    >
                                                                        <DxGroupItem :colCount="3">
                                                                            <DxColCountByScreen :xs="1" :sm="1"/>
                                                                            <DxSimpleItem
                                                                                :editor-options="{
                                                                                      value: offerEdit.rollingStockUnitTypeId,
                                                                                      dataSource: storeRollingStockUnitTypes,
                                                                                      displayExpr: 'rollingStockUnitTypeName',
                                                                                      valueExpr: 'rollingStockUnitTypeId',
                                                                                      showClearButton: true,
                                                                                      showDataBeforeSearch: false
                                                                                      }"
                                                                                data-field="rollingStockUnitTypeId"
                                                                                editor-type="dxSelectBox"
                                                                            >
                                                                                <DxLabel text="Тип ПС"/>
                                                                                <DxRequiredRule message="Укажите Тип ПС"/>
                                                                            </DxSimpleItem>
                                                                            <DxSimpleItem
                                                                                :editor-options="{value: offerEdit.amount}"
                                                                                data-field="amount"
                                                                                editor-type="dxNumberBox"
                                                                            >
                                                                                <DxLabel text="Новое предложение"/>
                                                                                <DxRequiredRule/>
                                                                            </DxSimpleItem>
                                                                            <DxSimpleItem
                                                                                :editor-options="{value: offerEdit.currencyId, items: currencys, displayExpr: 'сurrencyName', valueExpr: 'сurrencyId', showClearButton: true, searchEnabled: true}"
                                                                                data-field="currencyId"
                                                                                editor-type="dxSelectBox"
                                                                            >
                                                                                <DxLabel text="Валюта"/>
                                                                                <DxRequiredRule message="Укажите Валюту"/>
                                                                            </DxSimpleItem>
                                                                        </DxGroupItem>
                                                                        <DxSimpleItem
                                                                            :editor-options="{value: offerEdit.note}"
                                                                            data-field="note"
                                                                            editor-type="dxTextBox"
                                                                        >
                                                                            <DxLabel text="Комментарий"/>
                                                                        </DxSimpleItem>
                                                                    </DxForm>
                                                                </div>
                                                                <div class="modal-footer d-flex justify-content-between">
                                                                    <button type="button" class="btn btn-danger"
                                                                            @click="DelOffer(cargoItem.cargoLotId, cargoItem.agentOffer.cargoOfferId)">
                                                                        Удалить
                                                                    </button>
                                                                    <div>
                                                                        <button type="button" class="btn btn-primary"
                                                                                @click="EditOffer(cargoItem.cargoLotId, cargoItem.agentOffer.cargoOfferId)"
                                                                                :disabled="isSendOffer">Сохранить
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="!cargoItem.agentOffer" class="col-12 col-sm-4 pt-2 pt-sm-1 text-right">
                                                <span class="small text-muted">НЕТ ПРЕДЛОЖЕНИЯ</span>
                                            </div>
                                            <div v-if="cargoItem.agentOffer" class="col-12 col-sm-4 pt-2 pt-sm-1 text-right">
                                                <span class="text-muted">{{ cargoItem.agentOffer.amount | formatMoney }} {{ cargoItem.agentOffer.currencyShortName }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <DxButton
                                text="Показать еще"
                                type="default"
                                styling-mode="contained"
                                @click="openMarketplace()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div id="company-in-numbers" class="company-in-numbers">
            <div class="pt-5 pb-3">
                <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="title">Компания в цифрах</div>
                    </div>
                </div>
            </div>
            <div class="bg-white py-4">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-7">
                            <div class="media mb-3">
                                <img src="@/assets/images/company-in-numbers/confirmed.png" class="align-self-start mr-3 img-48" alt="8 лет на рынке международных грузовых автомобильных перевозок">
                                <div class="media-body">
                                    <h3 class="mt-0 text-primary font-28 font-md-34 mb-1">8 лет</h3>
                                    <p class="text-primary font-18">на рынке международных грузовых автомобильных перевозок</p>
                                </div>
                            </div>
                            <div class="media mb-3">
                                <img src="@/assets/images/company-in-numbers/confirmed.png" class="align-self-start mr-3 img-48" alt="Наша география страны  Европы, СНГ, Турция, Китай, перевозки  по всему Казахстану">
                                <div class="media-body">
                                    <h3 class="mt-0 text-primary font-28 font-md-34 mb-1">Наша география</h3>
                                    <p class="text-primary font-18">страны Европы, СНГ, Турция, Китай, перевозки по всему Казахстану</p>
                                </div>
                            </div>
                            <div class="media mb-3">
                                <img src="@/assets/images/company-in-numbers/confirmed.png" class="align-self-start mr-3 img-48" alt="Свыше 100 Партнеров доверяют нам услуги грузоперевозок">
                                <div class="media-body">
                                    <h3 class="mt-0 text-primary font-28 font-md-34 mb-1">Свыше 100 Партнеров</h3>
                                    <p class="text-primary font-18">доверяют нам услуги грузоперевозок</p>
                                </div>
                            </div>
                            <div class="media mb-3">
                                <img src="@/assets/images/company-in-numbers/confirmed.png" class="align-self-start mr-3 img-48" alt="свыше 15 000 грузоперевозок мы осуществили">
                                <div class="media-body">
                                    <h3 class="mt-0 text-primary font-28 font-md-34 mb-1">свыше 15 000 грузоперевозок</h3>
                                    <p class="text-primary font-18">мы осуществили</p>
                                </div>
                            </div>
                            <div class="media">
                                <img src="@/assets/images/company-in-numbers/confirmed.png" class="align-self-start mr-3 img-48" alt="свыше 300 000 тонн различных грузов мы перевезли">
                                <div class="media-body">
                                    <h3 class="mt-0 text-primary font-28 font-md-34 mb-1">свыше 300 000 тонн</h3>
                                    <p class="text-primary font-18">различных грузов мы перевезли</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 col-lg-5">
                            <img src="@/assets/images/company-in-numbers/volume-sales.png" class="img-fluid mx-auto d-block mt-3" alt="Объем продаж за 2023 год составил 1,7 млрд тенге">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        <!-- Modals -->
        <div class="modal fade" id="noLoginModal" tabindex="-1" aria-labelledby="noLoginModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="noLoginModalLabel">Вы не авторизованы</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="!isCabinetDisabled">
                        Чтобы сделать/посмотреть предложение, вам нужно
                        <div class="text-center">
                            <DxButton
                                    text="войти"
                                    type="default"
                                    styling-mode="outlined"
                                    @click="openLR('Login')"
                                    class="my-3"
                            />
                        </div>
                        <div class="text-center">
                            или
                        </div>
                        <div class="text-center">
                            <DxButton
                                    text="зарегистрироваться"
                                    type="default"
                                    styling-mode="outlined"
                                    @click="openLR('Registration')"
                                    class="my-3"
                            />
                        </div>
                    </div>
                    <div class="modal-body" v-if="isCabinetDisabled">
                        <p>Для выполнения данных действий Вам требуется пройти регистрацию.</p>
                        <p>По всем вопросам Вы можете связаться с нами по телефону:<br>
                            +7 (727) 312-21-10 или jivochat</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isCabinetDisabled } from '../../../environment/environment';
    import Vue from 'vue';
    import jQuery from 'jquery';

    let $ = jQuery;
    import {Header, Footer} from '../../shared/components';
    import headerRoutes from './header-routes';
    import localStore from './store';
    import {DxLoadIndicator} from 'devextreme-vue/load-indicator';
    import DxButton from 'devextreme-vue/button';
    import moment from 'moment';
    import {mapGetters} from 'vuex';
    import CustomStore from 'devextreme/data/custom_store';
    import {httpClient} from '../../shared/services';
    import {
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxRequiredRule,
        DxGroupItem,
        DxColCountByScreen,
    } from 'devextreme-vue/form';

    // $(document).ready(function () {
    //
    // });

    export default {
        name: 'Home',
        components: {
            Header,
            Footer,
            DxLoadIndicator,
            DxButton,
            DxForm,
            DxSimpleItem,
            DxLabel,
            DxRequiredRule,
            DxGroupItem,
            DxColCountByScreen
        },
        data() {
            return {
                isCabinetDisabled,
                headerRoutes,
                currencys: null,
                cargos: null,
                skeep: 0,
                take: 6,
                orderField: "pickupDate",
                orderDesc: true,
                isSendOffer: false,
                errorMessageAddOffer: "",
                errorMessageEditOffer: "",
                offerNew: {
                    rollingStockUnitTypeId: "",
                    amount: "",
                    currencyId: ""
                },
                offerEdit: {
                    rollingStockUnitTypeId: "",
                    amount: "",
                    currencyId: ""
                },
                labelLocation: 'top',
                storeRollingStockTypeId: "",
                storeRollingStockUnitTypes: new CustomStore({
                    key: 'rollingStockUnitTypeId',
                    byKey: function () {
                        //console.log(key);
                        return {
                            "rollingStockUnitTypeId": window.rollingStockUnitTypeId,
                            "rollingStockUnitTypeName": window.rollingStockUnitTypeName
                        };
                    },
                    load: (loadOptions) => {
                        let searchValue = loadOptions.searchValue != null ? loadOptions.searchValue : '';

                        let filter = searchValue != '' ? `,{"rollingStockUnitTypeName":{"op":"con","value":"${searchValue}"}}` : '';

                        return httpClient.get(`v2/Catalog/RollingStockUnitTypes?filter={"rollingStockTypeId":{"op":"eq","value":"${this.storeRollingStockTypeId}"}}${filter}`)
                            .then((data) => {
                                return {
                                    key: 'rollingStockUnitTypeId',
                                    data: data.data.items,
                                    totalCount: data.totals,
                                    summary: data.totals,
                                    groupCount: data.count,
                                };
                            })
                            .catch(() => {
                                throw 'Data Loading Error';
                            });
                    }
                }),
                selectRoute: null,
                selectOffers: null
            }
        },
        mounted() {
            Vue.nextTick(function () {
                let leftArrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="7.365" height="12.92" viewBox="0 0 7.365 12.92"><path d="M97.4,7.1l5.556,5.555a.9.9,0,0,0,1.28-1.279L99.323,6.46l4.916-4.915a.9.9,0,0,0-1.28-1.28L97.4,5.82a.9.9,0,0,0,0,1.279Z" transform="translate(-97.139 0)" fill="#fff"></path></svg>';
                let rightArrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="7.365" height="12.92" viewBox="0 0 7.365 12.92"><path id="Контур_1771" data-name="Контур 1771" d="M104.239,7.1l-5.556,5.555a.9.9,0,0,1-1.28-1.279l4.916-4.916L97.4,1.544a.9.9,0,0,1,1.28-1.28l5.556,5.555a.9.9,0,0,1,0,1.279Z" transform="translate(-97.139 0)" fill="#fff"></path></svg>';

                // home-slider
                $('.home-slider .owl-carousel').owlCarousel({
                    items: 1,
                    nav: true,
                    navText: [leftArrowSvg, rightArrowSvg],
                    dots: true,
                    loop: true,
                    autoplay: true,
                    autoplayTimeout: 5000,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn'
                });

                // main-direction-carousel
                $('.main-direction-carousel .owl-carousel').owlCarousel({
                    items: 3,
                    responsive: {
                        0: {
                            items: 2,
                            drag: true,
                            mouseDrag: true
                        },
                        768: {
                            items: 3,
                            drag: false,
                            mouseDrag: false
                        },
                        992: {
                            items: 3,
                            drag: false,
                            mouseDrag: false
                        }
                    },
                    margin: 12,
                    nav: false,
                    navText: [leftArrowSvg, rightArrowSvg],
                    dots: false,
                    loop: false,
                    autoplay: false
                });

                // home direction hover card event
                $('section .direction-item').hover(function () {
                    $(this).addClass('hover')
                }, function () {
                    $(this).removeClass('hover')
                });
            });
            this.getCurrencys();
            this.getCargos();
        },
        methods: {
            getCurrencys() {
                localStore.dispatch('getCurrencys').then(() => {
                    this.currencys = localStore.state.currencys;
                });
            },
            getCargos(
                order_field = this.orderField,
                order_desc = this.orderDesc,
                skeep = this.skeep,
                take = this.take
            ) {
                this.cargos = null;

                let tokenId = '';

                if (this.Agent) {
                    tokenId = this.Agent.tokenId;
                }

                localStore.dispatch('getCargos', {
                    order_field,
                    order_desc,
                    skeep,
                    take,
                    tokenId
                }).then(() => {
                    this.cargos = localStore.state.cargos;
                });
            },
            getStatus(cargoItem) {
                switch (cargoItem.status) {
                    case 'lotActive':
                        return '<i class="fas fa-hand-holding-usd text-success mr-1"></i>Активная';
                    case 'lotRejected':
                        return '<i class="fas fa-times-circle text-danger mr-1"></i>Аннулирована';
                    case 'lotProcessing':
                        return '<i class="fas fa-eye text-secondary mr-1"></i>На рассмотрении';
                    case 'lotApproved':
                        return '<i class="fas fa-check-square text-success mr-1"></i>Одобрена';
                    case 'lotOfferRejected':
                        return '<i class="fas fa-ban text-danger mr-1"></i>Отклонена';
                    case 'lotClosed':
                        return '<i class="fas fa-lock text-danger mr-1"></i>Закрыта';
                }
                return '- - -';
            },
            openMarketplace() {
                this.$router.push({name: 'Marketplace' });
            },
            openRoute(cargoLotId, tokenId = '') {
                this.selectRoute = null;

                if (this.Agent) {
                    tokenId = this.Agent.tokenId;
                }

                localStore.dispatch('getRoute', {
                    tokenId,
                    cargoLotId
                }).then(() => {
                    this.selectRoute = localStore.state.route;
                });

                $('#routeModal' + cargoLotId).modal('toggle');
            },
            openOffers(cargoLotId, tokenId = '') {
                this.selectOffers = null;

                if (this.Agent) {
                    tokenId = this.Agent.tokenId;
                }

                localStore.dispatch('getOffers', {
                    tokenId,
                    cargoLotId
                }).then(() => {
                    this.selectOffers = localStore.state.offers;
                });

                $('#offersModal' + cargoLotId).modal('toggle');
            },
            isViewTime(pickupDate) {
                return moment(pickupDate).format('HH:mm') != '00:00';
            },
            openLR(nameRoute) {
                $('#noLoginModal').modal('toggle');
                this.$router.push({name: nameRoute, query: {redirect: this.$route.path}});
            },
            openAddOfferModal(cargoLotId, rollingStockTypeId) {
                this.storeRollingStockTypeId = rollingStockTypeId;
                this.errorMessageAddOffer = "";
                this.$refs['addOfferFormRef' + cargoLotId][0].instance.resetValues();
                this.isSendOffer = false;
                $('#addOfferModal' + cargoLotId).modal('toggle');
            },
            AddOffer(cargoLotId) {
                this.isSendOffer = true;
                this.errorMessageAddOffer = "";
                let result = this.$refs['addOfferFormRef' + cargoLotId][0].instance.validate();

                if (result.isValid) {
                    const {rollingStockUnitTypeId, amount, currencyId} = this.offerNew;

                    httpClient.post(`v2/Marketplace/Cargos/${cargoLotId}/Offers?tokenId=${this.Agent.tokenId}`, {
                        rollingStockUnitTypeId: rollingStockUnitTypeId,
                        amount: amount,
                        currencyId: currencyId
                    }).then(() => {
                        this.getCargos();
                        $('#addOfferModal' + cargoLotId).modal('toggle');
                        this.errorMessageAddOffer = "";
                    }).catch(this.handleErrorAddOffer);
                } else {
                    this.isSendOffer = false;
                }
            },
            handleErrorAddOffer: function (error) {
                if (error.response.status === 400) {
                    if(error.response.data) {
                        let errorMessage = error.response.data;

                        this.errorMessageAddOffer = errorMessage;
                    } else {
                        this.errorMessageAddOffer = "Ошибка при подаче предложения. Проверьте указанные вами данные и попробуйте еще раз.";
                    }
                } else {
                    this.errorMessageAddOffer = "Ошибка при подаче предложения. Проверьте указанные вами данные и попробуйте еще раз.";
                }

                this.isSendOffer = false;
                console.error(error);
            },
            openEditOfferModal(cargoLotId, rollingStockTypeId, agentOffer) {
                this.storeRollingStockTypeId = rollingStockTypeId;
                this.errorMessageEditOffer = "";
                //let dxsel = this.$refs['editOfferFormRef'+cargoLotId][0].instance.getEditor("rollingStockUnitTypeId");
                window.rollingStockUnitTypeId = agentOffer.rollingStockUnitTypeId;
                window.rollingStockUnitTypeName = agentOffer.rollingStockUnitTypeName;

                this.offerEdit = {
                    rollingStockUnitTypeId: agentOffer.rollingStockUnitTypeId,
                    amount: agentOffer.amount,
                    currencyId: agentOffer.currencyId
                };

                this.isSendOffer = false;
                $('#editOfferModal' + cargoLotId).modal('toggle');
            },
            EditOffer(cargoLotId, cargoOfferId) {
                this.isSendOffer = true;
                this.errorMessageEditOffer = "";
                let result = this.$refs['editOfferFormRef' + cargoLotId][0].instance.validate();

                if (result.isValid) {
                    const {rollingStockUnitTypeId, amount, currencyId} = this.offerEdit;

                    httpClient.post(`v2/Marketplace/Cargos/${cargoLotId}/Offers?tokenId=${this.Agent.tokenId}`, {
                        cargoOfferId: cargoOfferId,
                        rollingStockUnitTypeId: rollingStockUnitTypeId,
                        amount: amount,
                        currencyId: currencyId
                    }).then(() => {
                        this.getCargos();
                        $('#editOfferModal' + cargoLotId).modal('toggle');
                        this.errorMessageEditOffer = "";
                    }).catch(this.handleErrorEditOffer);
                } else {
                    this.isSendOffer = false;
                }
            },
            handleErrorEditOffer: function (error) {
                if (error.response.status === 400) {
                    if(error.response.data) {
                        let errorMessage = error.response.data;

                        this.errorMessageEditOffer = errorMessage;
                    } else {
                        this.errorMessageEditOffer = "Ошибка при изменении предложения. Проверьте указанные вами данные и попробуйте еще раз.";
                    }
                } else {
                    this.errorMessageEditOffer = "Ошибка при изменении предложения. Проверьте указанные вами данные и попробуйте еще раз.";
                }

                this.isSendOffer = false;
                console.error(error);
            },
            DelOffer(cargoLotId, cargoOfferId) {
                httpClient.delete(`v2/Marketplace/Cargos/${cargoLotId}/Offers/${cargoOfferId}?tokenId=${this.Agent.tokenId}`).then(() => {
                    this.getCargos();
                    $('#editOfferModal' + cargoLotId).modal('toggle');
                    this.errorMessageEditOffer = "";
                }).catch(this.handleErrorDelOffer);
            },
            handleErrorDelOffer: function (error) {
                if (error.response.status === 400) {
                    if(error.response.data) {
                        let errorMessage = error.response.data;

                        this.errorMessageEditOffer = errorMessage;
                    } else {
                        this.errorMessageEditOffer = "Ошибка при удалении предложения. Попробуйте еще раз.";
                    }
                } else {
                    this.errorMessageEditOffer = "Ошибка при удалении предложения. Попробуйте еще раз.";
                }

                this.isSendOffer = false;
                console.error(error);
            },
        },
        computed: {
            ...mapGetters([
                'isLogged',
                'Agent'
            ])
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .company-in-numbers {
        .title {
            font-size: var(--size-26);
        }

        .img-48 {
            width: 48px;
        }
    }
</style>
